// lib
import { styled } from '@nykaa/ui-components';
import { PDP_CONTAINER_WIDTH } from 'shared/layouts/DetailsPage/components/ProductInfo/Desktop/constants';

export const Title = styled.div`
  height: 24px;
  width: 100%;
  margin: 0 0 ${({ theme }) => theme.spacing.spacing20} 0;

  ${({ theme }) => theme.typography.titleMedium};
`;

export const EcomPolicyCardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: ${PDP_CONTAINER_WIDTH}px;
`;

export const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing160};
  padding-top: ${({ theme }) => theme.spacing.spacing160};
  border-top: solid 1px ${({ theme }) => theme.colors.textOutline};
`;

export const PlaceHolder = styled.div`
  display: flex;
  height: 148px;
`;

export const EcomPolicyPlaceHolder = styled.div<{ noMargin?: boolean }>`
  height: 132px;
  width: 96px;
  margin-right: ${({ theme, noMargin }) => !noMargin && theme.spacing.spacing120};
  margin-top: ${({ theme }) => theme.spacing.spacing80};
  background-color: ${({ theme }) => theme.colors.shimmerBg};
`;
